<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <img alt="logo" src="/img/clubedemidia-world-escudo.png" class="d-none d-print-inline"/>
                    <div>
                        <h3>Relatório de <b>{{ customer_display_name }}</b></h3>
                        <i>{{ search.date }}</i>
                    </div>
                </div>
                <div class="text-right" v-show="!show_filter">
                    <button class="btn btn-primary" @click="print()">Imprimir</button>
                </div>
                <div class="dropdown-divider"></div>
            </div>
            <div class="card-body d-print-none">
                <div class="form-group row">
                    <div class="col-lg-3">
                        <label>Mês referência</label>
                        <select
                            ref="date"
                            v-model="search.date"
                            class="form-control"
                            placeholder="MM/AAAA"
                        >
                            <option v-for="value in 26" :value="format(value)" v-text="format(value)"></option>
                        </select>
                    </div>

                    <div class="col-lg-3">
                        <label>&nbsp;</label>
                        <div class="d-flex justify-content-end">
                            <button class="btn btn-primary mr-1" @click="load()">Consultar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="text-left">
                    <h3>
                        Contrato <b>{{ getCoinLabel(contract_time) }}</b> |
                        Mês Anterior <b>{{ getCoinLabel(previous_balance) }}</b> |
                        Horas líquidas <b>{{ getCoinLabel(previous_balance_contract_time) }}</b>
                    </h3>
                </div>
                <table class="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>Número</th>
                        <th>Título</th>
                        <th>Fase atual</th>
                        <th>Tipo de<br />Serviço</th>
                        <th>Data<br />de Início</th>
                        <th>Status<br />do Job</th>
                        <th>Tempo de<br />Execução</th> <!-- Informado no ticket ou padrao -->
                        <th>Saldo<br />de {{ coin_name }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!rows.length">
                        <td colspan="8" class="text-center">Sem dados para exibir</td>
                    </tr>
                    <tr v-else v-for="row in rows">
                        <td>
                            <a :href="'#/ticket/' + row._id">{{ row.num }}</a>
                        </td>
                        <td>{{ row.name }}</td>
                        <td>{{ row.phase_name }}</td>
                        <td>{{ row.description }}</td>
                        <td>{{ format(row.start_at) }}</td>
                        <td>{{ row.status }}</td>
                        <td>{{ getCoinLabel(row.execution_time_h) }}</td>
                        <td>{{ getCoinLabel(row.balance_h) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {H} from 'hennig-common'
import moment from 'moment'
import {setArr, getCoinLabel} from '../../common'

export default {
    name: 'WorkedHours',
    data () {
        return {
            search: {
                date: '',
            },
            customer_display_name: '',
            contract_time: 0,
            previous_balance: 0,
            previous_balance_contract_time: 0,
            rows: [],
            currentMonth: moment().format('MM/YYYY'),
            coin_name: '',
        }
    },
    watch: {
        'search.customer_id' (new_value) {
            if (new_value) {
                this.load()
            }
        }
    },
    beforeMount () {
        H.rpc('Customer', 'getCoinName', [window.auth.customer_id], r => {
            if (r) {
                this.coin_name = r.coin_name
            }
        })
    },
    mounted () {
        if (window.auth.user_type === 'C') {
            this.search.customer_id = window.auth.customer_id
            this.search.date = this.$route.params.mes || moment().format('MM/YYYY')
        } else {
            this.search.customer_id = window.auth.customer_id
            let reference = this.$route.params.reference || this.$route.params.mes || moment().format('MM/YYYY')
            // Se vier no formato YYYY-MM (comum em links), converte para MM/YYYY
            if (reference.match(/^\d{4}-\d{2}$/)) {
                reference = moment(reference, 'YYYY-MM').format('MM/YYYY')
            }
            this.search.date = reference
        }

        if (this.search.customer_id && this.search.date) {
            this.load()
        }
    },
    methods: {
        getCoinLabel,
        fillCustomer (row) {
            this.customer_display_name = row.trade_name
            this.coin_name = row.control_type || this.coin_name
        },
        load () {
            H.rpc('Customer', 'workedHoursReport', [this.search], r => {
                if (r) {
                    setArr(this, 'rows', r.rows)
                    this.contract_time = r.header.contract_time || 0
                    this.previous_balance = r.header.previous_balance || 0
                    this.previous_balance_contract_time = r.header.previous_balance_contract_time || 0
                    this.customer_display_name = r.header.customer_name || ''
                }
            })
        },
        format (value) {
            if (value-1 === 0) {
                return this.currentMonth
            }

            return moment().subtract(value-1, 'month').format('MM/YYYY')
        }
    }
}
</script>

